// Sugar Alarm — the meal photo screen's refusal lines (moved out of
// PhotoMealScreen in cycle 457 so the rule is testable).
//
// ⚠ A HEIC photo is refused with the operator's line WHATEVER code the
// server chose: when the on-device conversion fails the original is sent,
// and the server answers `415 heic_not_supported` for a file declared
// image/heic but `415 unsupported_image_type` for one a picker declared
// image/heif or sent with no type. The screen knows the original was HEIC.

import { HEIC_NOT_SUPPORTED_LINE, PHOTO_TOO_LARGE_LINE } from "../../api/heroAvatar";

export function mealPhotoErrorMessage(
  status: number,
  timedOut: boolean,
  code?: string,
  originalWasHeic = false,
): string {
  if (timedOut) return "Took too long — try again or count manually.";
  if (code === "heic_not_supported") return HEIC_NOT_SUPPORTED_LINE;
  if (status === 415 && originalWasHeic) return HEIC_NOT_SUPPORTED_LINE;
  if (code === "too_many_pixels") return PHOTO_TOO_LARGE_LINE;
  if (status === 422) return "Couldn't read that photo — try a different one or count manually.";
  if (status === 413) return "Photo is too large — try a smaller image.";
  if (status === 415) return "That photo format isn't supported. Try a JPEG or PNG.";
  if (status === 429) return "Slow down — try again in a few seconds.";
  if (status === 403) return "Photo estimates aren't available on this device.";
  if (status === 503) return "Photo estimates aren't configured on the server.";
  return "Estimate failed — try again or count manually.";
}
